import { render, staticRenderFns } from "./CustomersCohorts.vue?vue&type=template&id=462f60fa&scoped=true"
import script from "./CustomersCohorts.vue?vue&type=script&lang=js"
export * from "./CustomersCohorts.vue?vue&type=script&lang=js"
import style0 from "./CustomersCohorts.vue?vue&type=style&index=0&id=462f60fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f60fa",
  null
  
)

export default component.exports